// extracted by mini-css-extract-plugin
export default {"productDescription":"haa-z","featuredDescription":"iaa-z","description":"jaa-z","more":"kaa-z","descriptionSku":"laa-z"};